import React from "react";
import { apiUrls } from "../../../actprep-ui/utils/urls";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import PaginatedTable from "../../../actprep-ui/components/PaginatedTable";
import layout from "../../../actprep-ui/constants/layout";
import ChallengeForm from "../../../components/EditChallengeForm";
import { capitalize } from "../../../actprep-ui/utils/formatting";
import { useFilters } from "../../../actprep-ui/hooks/ui";
import { challengesFilters } from "../../../constants/filters";
import useDisclosure from "../../../actprep-ui/hooks/ui/useDisclosure";
import { sortingModes } from "../../../actprep-ui/constants/dataGrid";

export default function Challenges() {
  const challengesColumns = () => [
    {
      field: "subject",
      headerName: "Subject",
      width: 150,
      valueFormatter: (val) => capitalize(val),
    },
    {
      field: "order",
      headerName: "Order",
      width: 150,
    },
    {
      field: "test",
      headerName: "Test",
      width: 200,
      valueGetter: (val, row) => `${row.test.name}`,
    },
    {
      field: "first_question",
      headerName: "First Question",
      width: 150,
    },
    {
      field: "last_question",
      headerName: "Last Question",
      width: 150,
    },
    {
      field: "total_questions",
      headerName: "Total Questions",
      width: 150,
    },
    {
      field: "time_allowed",
      headerName: "Time Allowed",
      width: 150,
    },
  ];
  const { onToggle, onClose, isOpen } = useDisclosure();
  const { Filters, FiltersAppliedList, getFilterParams } = useFilters({
    name: "Challenge Filters",
    saveState: true,
    filtersConfig: challengesFilters,
    handleClose: onClose,
  });

  return (
    <>
      <Grid
        sx={{
          marginTop: `${layout.navBarHeight + 1}rem`,
        }}
        size={12}
      >
        <ContentBox style={{ maxHeight: "80vh", height: "500rem" }}>
          <Typography variant="h5" fontWeight={"bold"}>
            Challenges
          </Typography>
          <Box sx={{ height: "90%" }}>
            <PaginatedTable
              searchable
              tableName={"Challenges"}
              addRowButtonText="Add Challenge"
              apiUrl={apiUrls.admin.challenges()}
              columns={challengesColumns}
              urlParams={{
                keep_related: "true",
                search_params: getFilterParams(),
              }}
              disableCellFocus
              getRowTitle={({ row }) =>
                `${row?.test?.name} ${capitalize(row?.subject)} Questions ${
                  row?.questions_to_do
                }`
              }
              initialState={{
                pinnedColumns: {
                  right: ["actions"],
                },
              }}
              EditForm={ChallengeForm}
              CreationForm={ChallengeForm}
              pageSizeOptions={[10, 50, 100, 200, 500]}
              FiltersAppliedList={FiltersAppliedList}
              onFiltersClick={onToggle}
              sortingMode={sortingModes.SERVER}
            />
          </Box>
        </ContentBox>
      </Grid>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={onClose}
        variant={"temporary"}
      >
        <Box
          sx={{
            paddingTop: `${layout.navBarHeight + 1}rem`,
            width: "20rem",
          }}
        >
          <Filters />
        </Box>
      </Drawer>
    </>
  );
}
